import { render, staticRenderFns } from "./notification-predefined-templates-modal.vue?vue&type=template&id=38053031&"
import script from "./notification-predefined-templates-modal.ts?vue&type=script&lang=ts&"
export * from "./notification-predefined-templates-modal.ts?vue&type=script&lang=ts&"
import style0 from "./notification-predefined-templates-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports